import React from 'react';
import './uiPending.scss';

export interface TabItem<T extends string> {
  key: T;
  label: React.ReactNode;
  /** Small trailing text, e.g. a count. */
  meta?: React.ReactNode;
}

interface TabsProps<T extends string> {
  tabs: TabItem<T>[];
  active: T;
  onChange: (key: T) => void;
  label: string;
}

/** Underline tabs that switch a panel in place. Render the active panel below. */
function Tabs<T extends string>({ tabs, active, onChange, label }: TabsProps<T>) {
  return (
    <div className="sls-tabs" role="tablist" aria-label={label}>
      {tabs.map((t) => (
        <button
          key={t.key}
          type="button"
          role="tab"
          className="sls-tabs__tab"
          aria-selected={t.key === active}
          onClick={() => onChange(t.key)}
        >
          {t.label}
          {t.meta != null && <span className="sls-tabs__meta">{t.meta}</span>}
        </button>
      ))}
    </div>
  );
}

export default Tabs;
